import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirm-publication',
  templateUrl: './confirm-publication.component.html',
})
export class ConfirmPublicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
